import { useLang } from 'hooks/lang';

import { usePackageProjectRemoval, invoiceControlStatusConfig } from 'entities';

import { Button } from 'components/Blocks';
import { RemoveProjectIcon } from 'components/Icons';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';

import { omit } from 'utils/object';

export function RemovePackageButton() {
  const { t } = useLang();

  const {
    project: { invoice, id },
    updateProject,
  } = useProjectProfile();

  const { removeProjectFromPackage, loading } = usePackageProjectRemoval({
    onSuccess: () =>
      updateProject((old) => ({
        ...old,

        invoice: {
          ...omit(old.invoice, ['package']),
          status: invoiceControlStatusConfig.readyToInvoice.code,
        },
      })),
  });

  const handleRemoveClick = () =>
    removeProjectFromPackage({
      packageId: invoice.package?.id as string,
      projectId: id,
    });

  return (
    <Button variant="outlined" color="destructive" onClick={handleRemoveClick} loading={loading}>
      <RemoveProjectIcon size={20} />
      {t('detach-project-from-package')}
    </Button>
  );
}
